import {
  CREATE_SITE_GROUP,
  EDIT_SITE_GROUP,
  RECEIVE_SITE_GROUPS,
  REMOVE_SITE_GROUPS,
  REQUEST_CUSTOMER_SITE_GROUPS,
  REQUEST_SITE_GROUP,
} from '@sophocles/entities/SiteGroup/siteGroupActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SITE_GROUPS:
      return action.siteGroups;
    case REQUEST_CUSTOMER_SITE_GROUPS:
    case REQUEST_SITE_GROUP:
    case EDIT_SITE_GROUP:
    case CREATE_SITE_GROUP:
    default:
      return state;
  }
}

export function siteGroupReducer(state = Map(), action) {
  switch (action.type) {
    case REMOVE_SITE_GROUPS:
      return Map();
    case RECEIVE_SITE_GROUPS:
    case REQUEST_CUSTOMER_SITE_GROUPS:
    case REQUEST_SITE_GROUP:
    case EDIT_SITE_GROUP:
    case CREATE_SITE_GROUP:
      return state.merge(getState(state, action));
    default:
      return state;
  }
}
